export default function contactForms() {
	// This function is responsible for getting the index on the clicked tab
	const tabs = () => {
		const tabs = document.querySelectorAll('div.contact__select');
		tabs.forEach((el) => {
			el.addEventListener('click', function () {
				showHideForm([...el.parentElement.children].indexOf(el));
			});
		});
	};
	tabs();
	// This function is responsible for showing and hiding the contact forms
	const showHideForm = (index) => {
		const forms = document.querySelectorAll('div.gform_wrapper');
		forms.forEach((el) => {
			el.classList.remove('wpcf7--active');
		});
		forms[index].classList.add('wpcf7--active');
	};
}
